export default "__VITE_ASSET__CcxWjSO7__"